import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '@core/utilities/auth.guard';
import { Permission } from '@core/literals/permission.literal';
import { RedeploymentAuthorize } from '../../core/utilities/redeployment-authorize.guard';
import { Organizations } from '../../shared/literals/shared.literal';
import { FulfillmentOrderComponent } from './fulfillment-order/fulfillment-order.component';

const routes: Routes = [
  {
    path: '',
    component: FulfillmentOrderComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewIinvisionOrders, undefined))]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class FulfillmentOrdersRoutingModule {

}
